<template>
  <a-modal
    :width="480"
    centered
    wrap-class-name="coin-modal"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
  >
    <div slot="title">
      金币增减明细 ｜ {{ goldDetailObj.userName }}
      <div class="coin-title">
        <span class="coin-split"> | </span>
        <span class="coin-id"> ID：{{ goldDetailObj.userId }}</span>
      </div>
    </div>
    <a-table
      row-key="id"
      :scroll="{ y: 400 }"
      :loading="tableLoading"
      :columns="columns"
      :data-source="studentList"
      :pagination="false"
    >
      <div slot="operateTime" slot-scope="text">
        {{ text | formatTimeStr }}
      </div>
      <div slot="coinsNum" slot-scope="text">
        {{ text > 0 ? `+${text}` : text }}
      </div>
    </a-table>
    <div class="pagination">
      <a-pagination
        v-show="pagination.total > 0"
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
const columns = [
  {
    title: '金币数量',
    dataIndex: 'coinsNum',
    scopedSlots: { customRender: 'coinsNum' }
  },
  {
    title: '时间',
    dataIndex: 'operateTime',
    scopedSlots: { customRender: 'operateTime' }
  }
]

export default {
  name: 'GoldDetail',

  props: {
    visible: {
      type: Boolean,
      default: true
    },
    goldDetailObj: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.pagination.current = 1
        this.getList()
      }
    }
  },

  data() {
    return {
      columns,
      tableLoading: false,
      studentList: [1, 2],
      pagination: {
        pageSize: 50,
        total: 0,
        current: 1
      }
    }
  },
  filters: {
    formatTimeStr(record) {
      return record && `${moment(record).format('YYYY.MM.DD HH:mm:ss')}`
    }
  },
  methods: {
    getList() {
      this.tableLoading = true
      const searchParams = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        studentId: this.goldDetailObj.studentId
      }
      this.$service.coin.getCoinById(searchParams).then(res => {
        this.tableLoading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        this.studentList = res.list
      }).catch(err => {
        this.tableLoading = false
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleCancel() {
      this.studentList = []
      this.$emit('update:visible', false)
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang="less">
.coin-modal{
  .ant-table-wrapper .ant-table .ant-table-tbody > tr > td {
    color: #70788C;
  }
  .ant-modal-header{
    .coin-title{
      display: inline-block;
      vertical-align: bottom;
      .coin-split{
        color: #EBEDF0;
        display: inline-block;
        margin: 0 16px;
        font-size: 14px;
      }
      .coin-id{
        color: #70788C;
        font-size: 14px;
      }
    }
  }
  .ant-modal-body{
    .ant-table-wrapper .ant-table-thead{
      display: none;
    }
  }
  .ant-table-tbody > tr > td{
    border-bottom: 0;
  }
}
.pagination {
  text-align: right;
  padding-top: 20px;
}
</style>